import {Brand} from "../../../brand_service/model/Brand";
import * as angular from "angular";
import {IComponentController, IScope} from "angular";
import './brand-configuration-dialog.component.scss';
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {
    BrandServiceName,
    ImageUploadServiceName,
    ToastNotificationServiceName
} from "../../../utils/names/serviceNames";
import {BrandService} from "../../../brand_service/service/BrandService";
import {ImageService} from "../../../image_cropper/service/image.service";

interface BrandConfigurationDialogComponentScope extends IScope {
    showLoader: boolean;
    isNewBrand: boolean;
    toolbarText: string
    submitBrand: () => void;
    closeDialog: () => void;
    getBrandLogoUrl: () => string;
    updateBrandLogo: () => void;
    brand: Brand;
    brandLogoUrl: string;
    brandLogoSelected: boolean;
    updateFontColor: (fontColor: string) => void;
    submitBrandDisabled: () => boolean;
}

export class BrandConfigurationDialogComponent implements IComponentController {

    public static instance = ($event: MouseEvent, brand: Brand): angular.material.IDialogOptions => ({
        targetEvent: $event,
        fullscreen: true,
        clickOutsideToClose: true,
        controller: [
            '$scope',
            'brand',
            '$mdDialog',
            ToastNotificationServiceName,
            BrandServiceName,
            ImageUploadServiceName,
            BrandConfigurationDialogComponent
        ],
        parent: angular.element(document.body),
        template: require('./brand-configuration-dialog.component.html'),
        locals: {
            brand: brand
        }
    });

    constructor(private $scope: BrandConfigurationDialogComponentScope,
                private brand: Brand,
                private $mdDialog: angular.material.IDialogService,
                private toastNotificationService: ToastNotificationService,
                private brandService: BrandService,
                private imageService: ImageService) {
        $scope.brand = brand;
        $scope.updateFontColor = this.updateFontColor;
        $scope.getBrandLogoUrl = this.checkBrandLogoUrl;
        $scope.updateBrandLogo = this.updateBrandLogo;
        $scope.closeDialog = this.closeDialog;
        $scope.submitBrand = this.submitBrand;
        $scope.submitBrandDisabled = this.submitBrandDisabled;
        $scope.isNewBrand = brand.id == null;
        $scope.toolbarText = $scope.isNewBrand ? 'New Brand Configuration' : $scope.brand.name + ' Brand Configuration';
        this.checkBrandLogoUrl();
    }

    submitBrand = () => {
        this.$scope.showLoader = true;
        if (this.$scope.isNewBrand) {
            this.saveBrand();
        } else {
            this.updateBrand();
        }
    };

    private updateBrand() {
        this.brandService.updateBrand(this.$scope.brand)
            .then(resp => {
                this.$scope.showLoader = false;
                this.toastNotificationService.generateSuccessMessage("Successfully updated the brand!");
                this.$mdDialog.hide(resp);
            }, err => {
                this.$scope.showLoader = false;
                this.toastNotificationService.generateErrorMessage("Failed to update the brand");
            });
    }

    private saveBrand() {
        this.brandService.saveBrand(this.$scope.brand)
            .then(resp => {
                this.$scope.showLoader = false;
                this.toastNotificationService.generateSuccessMessage("Successfully created new brand!");
                this.$mdDialog.hide(resp);
            }, err => {
                this.$scope.showLoader = false;
                this.toastNotificationService.generateErrorMessage("Failed to create new brand");
            });
    }

    checkBrandLogoUrl = () => {
        let logo = this.$scope.brand.logo;
        if (logo) {
            this.$scope.brandLogoSelected = true;
            return logo.url;
        } else {
            this.$scope.brandLogoSelected = false;
            this.$scope.brand.logo = {url: '/app/images/logos/no-logo.svg'}
        }
    };

    closeDialog = () => {
        this.$mdDialog.cancel();
    };

    updateFontColor = (colorValue) => {
        this.$scope.brand.brandColorHex = colorValue;
    };

    updateBrandLogo = () => {
        this.$scope.showLoader = true;
        let formData = ImageService.getInputFormData('brand-logo-file-input');
        this.imageService.uploadImage(formData)
            .then(resp => {
                let logo = this.$scope.brand.logo;
                logo.fileName = resp.imageName;
                logo.url = resp.imageUrl;
                logo.id = resp.id;
                this.brandService.updateBrandLogo(this.brand.id, resp.id)
                    .then(resp => {
                        this.$scope.showLoader = false;
                        this.toastNotificationService.generateSuccessMessage('Successfully updated the brand logo');
                    });
            })
    };

    submitBrandDisabled = (): boolean => {
        return this.brand == null
            || this.isNullOrempty(this.brand.name)
            || this.isNullOrempty(this.brand.title)
            || this.isNullOrempty(this.brand.nmlsNumber)
            || this.isNullOrempty(this.brand.mainHeaderColor)
            || this.isNullOrempty(this.brand.sideHeaderColor)
            || this.isNullOrempty(this.brand.brandColorHex);
    };

    private isNullOrempty(s: string): boolean {
        return s == null || s == ""
    }
}